import { Component, inject } from '@angular/core';
import { MDBModalRef } from 'ng-uikit-pro-standard';
import { BaryComponentHelper } from '../../../../util/bary-component-helper';
import { BaryModalEvent, IBaryModalEvent } from '../../../../../../models/bary-modal-event';
import { FaDirectiveEnum } from '../../../../../../models/enums/fa-directive.enum';

@Component({
  templateUrl: './bary-modal-confirm-can-deactivate.component.html',
})
export class BaryModalConfirmCanDeactivateComponent {
  readonly #modalRef = inject(MDBModalRef);

  public action = BaryComponentHelper.generateAction<IBaryModalEvent>();
  public title?: string;
  public message?: string;
  public icon?: string;
  public isAlert: boolean = false;
  public buttons = {
    submit: '',
    second: '',
  };
  public class = '';

  protected readonly FAS = FaDirectiveEnum.FAS;

  public handleClick(from: any): void {
    this.action.next(new BaryModalEvent(from));
    this.#modalRef.hide();
  }
}
